var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e71313"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,17.2c-37.92928,0 -68.8,30.87072 -68.8,68.8c0,37.92928 30.87072,68.8 68.8,68.8c37.92928,0 68.8,-30.87072 68.8,-68.8c0,-37.92928 -30.87072,-68.8 -68.8,-68.8zM86,28.66667c31.73223,0 57.33333,25.6011 57.33333,57.33333c0,31.73223 -25.6011,57.33333 -57.33333,57.33333c-31.73223,0 -57.33333,-25.6011 -57.33333,-57.33333c0,-31.73223 25.6011,-57.33333 57.33333,-57.33333zM60.2,74.53333c-4.74965,0 -8.6,3.85035 -8.6,8.6c0,4.74965 3.85035,8.6 8.6,8.6c4.74965,0 8.6,-3.85035 8.6,-8.6c0,-4.74965 -3.85035,-8.6 -8.6,-8.6zM111.8,74.53333c-4.74965,0 -8.6,3.85035 -8.6,8.6c0,4.74965 3.85035,8.6 8.6,8.6c4.74965,0 8.6,-3.85035 8.6,-8.6c0,-4.74965 -3.85035,-8.6 -8.6,-8.6zM86,103.2c-8.69556,0 -15.60354,3.47651 -20.21224,6.83073c-2.55921,1.865 -3.12252,5.45127 -1.25832,8.01106c1.8642,2.55979 5.45029,3.12422 8.01067,1.26082c3.2689,-2.37912 7.82212,-4.63594 13.45989,-4.63594c5.63778,0 10.19099,2.25682 13.45989,4.63594c1.65623,1.20696 3.83063,1.43843 5.70383,0.60718c1.8732,-0.83125 3.16049,-2.59887 3.37678,-4.63677c0.21629,-2.03791 -0.67128,-4.03636 -2.32826,-5.24228c-4.6087,-3.35422 -11.51668,-6.83073 -20.21224,-6.83073z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.372c1a13fdda74fd06900c9091270c1d.svg";
export { ForwardRef as ReactComponent };